// assets/js/components/revenue-calculator/steps/step-3.js
var ui = require("../ui");
var validate = require("../validate");

function render(state, locale) {
    var d = state.d;
    // Always the ISO code: Intl gives "$" for some currencies and "DKK" for others (QA round 1,
    // item 15), and "$" alone is ambiguous between USD, CAD and AUD.
    var currencyLabel = d.currency ? _t("Average value per booking (%sym%)").replace("%sym%", d.currency) : _t("Average value per booking");

    var html = ui.stepLabel(_t("Step 3 of 6")) + ui.h2(_t("Your monthly revenue baseline")) +
        ui.sub(_t("Rough estimates are fine. We only need a realistic average."));

    html += ui.field({
        id: "rc-bookings-month", label: _t("Approximate bookings per month"), required: true,
        inner: ui.textInput({ id: "rc-bookings-month", type: "number", value: d.bookingsMonth, placeholder: _t("e.g. 80"), min: 1 })
    });
    html += ui.field({
        id: "rc-avg-booking-value", label: currencyLabel, required: true,
        inner: ui.textInput({ id: "rc-avg-booking-value", type: "number", value: d.avgBookingValue, placeholder: _t("e.g. 75"), min: 1 })
    });
    html += ui.field({
        id: "rc-repeat-visits", label: _t("Average repeat visits per client per year"),
        inner: ui.textInput({ id: "rc-repeat-visits", type: "number", value: d.repeatVisits, placeholder: _t("e.g. 6"), min: 1 })
    });
    html += ui.primaryButton({ id: "rc-continue-btn", label: _t("Continue") });
    return ui.card(html);
}

function bind(container, state, actions) {
    var d = state.d;
    container.querySelector("#rc-bookings-month").addEventListener("input", function (e) { actions.setField("bookingsMonth", e.target.value); });
    container.querySelector("#rc-avg-booking-value").addEventListener("input", function (e) { actions.setField("avgBookingValue", e.target.value); });
    container.querySelector("#rc-repeat-visits").addEventListener("input", function (e) { actions.setField("repeatVisits", e.target.value); });

    container.querySelector("#rc-continue-btn").addEventListener("click", function () {
        if (validate.isBlank(d.bookingsMonth) || validate.isBlank(d.avgBookingValue)) {
            actions.showError(validate.isBlank(d.bookingsMonth) ? "rc-bookings-month" : "rc-avg-booking-value", _t("Please fill in bookings per month and average booking value."));
            return;
        }
        var numErr = validate.firstNumberError(d, [
            { key: "bookingsMonth", id: "rc-bookings-month", min: 1, max: 1000000, integer: true },
            { key: "avgBookingValue", id: "rc-avg-booking-value", min: 1, max: 1000000 },
            { key: "repeatVisits", id: "rc-repeat-visits", min: 1, max: 1000, optional: true }
        ]);
        if (numErr) {
            actions.showError(numErr.id, numErr.message);
            return;
        }
        state.step = 4;
        actions.rerender();
    });
}

module.exports = { render: render, bind: bind };
